// Section 2 — Third-Party Partner Store onboarding
// Outside smoke shop / vendor / retailer. Distinct from `partner_affiliate`
// (affiliate team lead) — partner stores have a physical location and
// upload their own products.
import React from "react";
import PublicApply from "@/components/public/PublicApply";

export default function PartnerStoreSignup() {
  return (
    <PublicApply
      role="partner"
      roleTestId="partner-store-signup"
      defaultBusinessCategory="store"
      title="Plug your store into Lifted."
      blurb="For local smoke shops, vape stores, and retailers. Upload your products, set your location, and reach Lifted customers nearby. 10% partner fee. Admin approval required."
      extraFields={[
        { key: "partner_type", label: "Hidden partner type", placeholder: "store", hidden: true, defaultValue: "store" },
        { key: "store_name", label: "Store name", placeholder: "Acme Smoke Shop" },
        { key: "store_address", label: "Street address", placeholder: "123 Main St" },
        { key: "store_city", label: "City", placeholder: "Anchorage" },
        { key: "store_state", label: "State", placeholder: "AK" },
        { key: "store_zip", label: "ZIP code", placeholder: "99501" },
        { key: "store_website", label: "Website (optional)", placeholder: "https://" },
      ]}
    />
  );
}
